import React from 'react';

import Review from '../review/Review';

import type { ReviewListReviewFragment } from './__generated-gql-types__/ReviewList.generated';

interface ReviewListProps {
  className?: string;
  itemClassName?: string;
  reviews: ReviewListReviewFragment[];
  showCoachAttribution?: boolean;
}

export const ReviewList: React.FC<ReviewListProps> = ({
  className = '',
  itemClassName = '',
  reviews,
  showCoachAttribution,
}) => {
  return (
    <ul className={className}>
      {reviews.map((review) => (
        <li
          key={review.id}
          className="border-b border-leland-gray-stroke py-6 first:pt-0 last:border-b-0"
        >
          <Review
            className={itemClassName}
            review={review}
            viewAsCoach
            hideFor
            showCoachAttribution={showCoachAttribution}
          />
        </li>
      ))}
    </ul>
  );
};
